<script type="text/javascript" src="jquery/jquery-3.6.0.min.js"></script>
<div class="site">
    <app-loader *ngIf="loading" class="global-loader" [loading]="loading" [config]="loading_config" [progress]="progress"></app-loader>
    <div class="outlet">
        <router-outlet></router-outlet>
    </div>
    <!-- <app-footer *ngIf="!loading"></app-footer> -->
</div>